const modules = {
	versionDisplay: "versionDisplay",
	lightboxComponent: "lightboxComponent",
	formComponent: "form",
	formRepeatable: "formRepeatable",
	accordionComponent: "accordion",
	breadcrumbComponent: "breadcrumb",
	checkboxComponent: "checkbox",
	contactPersonsComponent: "contactPersons",
	datepickerComponent: "datepicker",
	faqComponent: "faq",
	fileUploadComponent: "fileUpload",
	galleryComponent: "gallery",
	headerComponent: "header",
	handlePagination: "handlePagination",
	inputFieldComponent: "input",
	jobsuche: "jobsuche",
	medienportalComponent: "medienportal",
	multiselectComponent: "multiselect",
	newsSearchComponent: "newsSearch",
	overlayComponent: "overlay",
	radiofieldComponent: "radiofield",
	searchComponent: "search",
	seminarRegistrationComponent: "seminarRegistration",
	selectComponent: "select",
	servicePanelComponent: "servicePanel",
	sliderContainerComponent: "sliderContainer",
	tabsComponent: "tabs",
	teaserManagingDirectorComponent: "teaserManagingDirector",
	teaserNewsletterComponent: "teaserNewsletter",
	tooltipComponent: "tooltip",
	youtubeVideoComponent: "youtubeVideo",

	// alertTickerComponent: "altert-ticker",
	// loadWithAjax: "loadWithAjax",
	// teaserSliderComponent: "teaser-slider",
	// bannerComponent: "banner",
	// textContentSliderComponent: "text-content-slider",
}

const loadedModules = {}

class DynamicModuleLoader {
	/**
	 * get the list of dynamic Modules
	 * @returns object
	 */
	get modules() {
		return modules
	}

	/**
	 * use webpack dynamic imports
	 * @param componentName {string}
	 * @param callback {function}
	 * @private
	 */
	_import(componentName, callback) {
		if (typeof componentName === "string" && typeof callback === "function") {
			let modulePromise

			switch (componentName) {
				case modules.versionDisplay:
					modulePromise = import(/* webpackChunkName: "versionDisplay" */ "../components/VersionDisplay")
					break
				case modules.lightboxComponent:
					modulePromise = import(/* webpackChunkName: "lightbox" */ "../components/Lightbox")
					break
				case modules.formRepeatable:
					modulePromise = import(
						/* webpackChunkName: "form-repeatable" */ "../../components/form-repeatable/form-repeatable"
					)
					break
				case modules.accordionComponent:
					modulePromise = import(/* webpackChunkName: "accordion" */ "../../components/accordion/accordion")
					break
				case modules.breadcrumbComponent:
					modulePromise = import(
						/* webpackChunkName: "breadcrumb" */ "../../components/breadcrumb/breadcrumb"
					)
					break
				case modules.checkboxComponent:
					modulePromise = import(/* webpackChunkName: "checkbox" */ "../../components/checkbox/checkbox")
					break
				case modules.contactPersonsComponent:
					modulePromise = import(
						/* webpackChunkName: "contact-persons" */ "../../components/contact-persons/contact-persons"
					)
					break
				case modules.datepickerComponent:
					modulePromise = import(
						/* webpackChunkName: "datepicker" */ "../../components/datepicker/datepicker"
					)
					break
				case modules.faqComponent:
					modulePromise = import(/* webpackChunkName: "faq" */ "../../components/faq/faq")
					break
				case modules.fileUploadComponent:
					modulePromise = import(
						/* webpackChunkName: "fileUpload" */ "../../components/file-upload/file-upload"
					)
					break
				case modules.formComponent:
					modulePromise = import(/* webpackChunkName: "form" */ "../../components/form/form")
					break
				case modules.galleryComponent:
					modulePromise = import(/* webpackChunkName: "gallery" */ "../../components/gallery/gallery")
					break
				case modules.headerComponent:
					modulePromise = import(/* webpackChunkName: "header" */ "../../components/header/header")
					break
				case modules.handlePagination:
					modulePromise = import(/* webpackChunkName: "handle-pagination" */ "../utils/HandlePagination")
					break
				case modules.inputFieldComponent:
					modulePromise = import(
						/* webpackChunkName: "inputField" */ "../../components/inputfield/inputfield"
					)
					break
				case modules.jobsuche:
					modulePromise = import(/* webpackChunkName: "jobsuche" */ "../../components/jobsuche/jobsuche")
					break
				case modules.medienportalComponent:
					modulePromise = import(
						/* webpackChunkName: "medienportal" */ "../../components/medienportal/medienportal"
					)
					break
				case modules.multiselectComponent:
					modulePromise = import(
						/* webpackChunkName: "multiselect" */ "../../components/multiselect/multiselect"
					)
					break
				case modules.newsSearchComponent:
					modulePromise = import(
						/* webpackChunkName: "newsSearch" */ "../../components/news-search/news-search"
					)
					break
				case modules.seminarRegistrationComponent:
					modulePromise = import(
						/* webpackChunkName: "seminarRegistration" */ "../../components/seminar-registration/seminar-registration"
					)
					break
				case modules.overlayComponent:
					modulePromise = import(/* webpackChunkName: "overlay" */ "../../components/overlay/overlay")
					break
				case modules.radiofieldComponent:
					modulePromise = import(
						/* webpackChunkName: "radiofield" */ "../../components/radiofield/radiofield"
					)
					break
				case modules.searchComponent:
					modulePromise = import(/* webpackChunkName: "search" */ "../../components/search/search")
					break
				case modules.selectComponent:
					modulePromise = import(/* webpackChunkName: "select" */ "../../components/select/select")
					break
				case modules.servicePanelComponent:
					modulePromise = import(
						/* webpackChunkName: "service-panel" */ "../../components/service-panel/service-panel"
					)
					break
				case modules.sliderContainerComponent:
					modulePromise = import(
						/* webpackChunkName: "slider-container" */ "../../components/slider-container/slider-container"
					)
					break
				case modules.tabsComponent:
					modulePromise = import(/* webpackChunkName: "tabs" */ "../../components/tabs/tabs")
					break
				case modules.teaserManagingDirectorComponent:
					modulePromise = import(
						/* webpackChunkName: "teaser-managing-director" */ "../../components/teaser-managing-director/teaser-managing-director"
					)
					break
				case modules.teaserNewsletterComponent:
					modulePromise = import(
						/* webpackChunkName: "teaser-newsletter" */ "../../components/teaser-newsletter/teaser-newsletter"
					)
					break
				case modules.tooltipComponent:
					modulePromise = import(/* webpackChunkName: "tooltip" */ "../../components/tooltip/tooltip")
					break
				case modules.youtubeVideoComponent:
					modulePromise = import(
						/* webpackChunkName: "youtube-video" */ "../../components/youtube-video/youtube-video"
					)
					break

				// 	case modules.accordionComponent:
				// 		modulePromise = import( /* webpackChunkName: "accordion" */ '../../components/accordion/accordion')
				// 		break
				// 	case modules.alertTickerComponent:
				// 		modulePromise = import( /* webpackChunkName: "alert-ticker" */ '../../components/alert-ticker/alert-ticker')
				// 		break
				// 	case modules.teaserSliderComponent:
				// 		modulePromise = import( /* webpackChunkName: "tabs" */ '../../components/teaser-slider/teaser-slider')
				// 		break
				// 	case modules.bannerComponent:
				// 		modulePromise = import( /* webpackChunkName: "banner" */ '../../components/banner/banner')
				// 		break
				// 	case modules.textContentSliderComponent:
				// 		modulePromise = import( /* webpackChunkName: "textContentSlider" */ '../../components/text-content-slider/text-content-slider')
				// 		break
				// 	default:
				// 		console.warn('Module not found')
				// 		break
			}

			modulePromise.then((component) => {
				callback(component.default)
			})
		}
	}

	/**
	 * Dynamically Module Loader
	 * @param condition {boolean}
	 * @param componentName {string}
	 * @param onLoadComponent {function}
	 */
	load(condition, componentName, onLoadComponent = undefined) {
		if (condition) {
			if (!loadedModules[componentName]) {
				this._import(componentName, (Component) => {
					if (typeof onLoadComponent === "function") {
						onLoadComponent(Component)
					} else {
						new Component()
					}
					loadedModules[componentName] = Component
				})
			} else {
				if (typeof onLoadComponent === "function") {
					onLoadComponent(loadedModules[componentName])
				}
			}
		}
	}
}

export default new DynamicModuleLoader()
